import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Otb/PlanProvider'

export const parsePlanOtbExportData = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  const headerFormatted = {
    configuracaoGrid: {
      periodo: headers[0].columns[0]?.show,
      empresaId: headers[0].columns[1]?.show,

      categoriaCompactaId: headers[1].columns[0]?.show,
      categoriaCompactaDescricao: headers[1].columns[1]?.show,

      categoriaId: headers[2].columns[0]?.show,
      categoriaDescricao: headers[2].columns[1]?.show,

      estoqueInicial: headers[3].columns[0]?.show,
      aReceber: headers[3].columns[1]?.show,
      vendaPlanejadaPCL: headers[3].columns[2]?.show,
      vendaPlanejadaProjetada: headers[3].columns[3]?.show,
      compraProjetada: headers[3].columns[4]?.show,
      estoqueFinal: headers[3].columns[5]?.show,
      estoqueFinalAjustado: headers[3].columns[6]?.show
    }
  }

  return {
    ...paramsToSend,
    ...headerFormatted
  }
}
